export const MODULE_NAME = 'audiences';
export const AUDIENCES_ROUTE = `/${MODULE_NAME}`;
